module.exports = __webpack_public_path__ + "static/media/hu.a8abaf37.svg";